<template>
  <div class="home">
    <BerandaView />
    <AboutView />
    <ServiceView/>
    <ClientView/>
    <TechnologyView/>
    <FaqView/>
    <NewsView/>
    <SdgsView/>
    <KarirView/>
    <ContactView/>
  </div>
</template>

<script>
import BerandaView from './components/views/Beranda/BerandaView.vue';
import AboutView from './components/views/About/AboutView.vue';
import ServiceView from './components/views/Service/ServiceView.vue';
import ClientView from './components/views/Client/ClientView.vue';
import FaqView from './components/views/FAQ/FaqView.vue';
import ContactView from './components/views/Contact/ContactView.vue';
import SdgsView from './components/views/Sdgs/SdgsView.vue';
import TechnologyView from './components/views/Technology/TechnologyView.vue';
import NewsView from './components/views/News/NewsView.vue';
import KarirView from './components/views/Karir/KarirView.vue';

export default {
  name: 'HomeView',
  components: {
    BerandaView,
    AboutView,
    ServiceView,
    ClientView,
    FaqView,
    ContactView,
    SdgsView,
    TechnologyView,
    NewsView,
    KarirView
  }
}
</script>
